import loadBranchApi from '@zocdoc/components/src/utils/loadBranchApi';

export const createLinkData = ({
    branchDeepLink,
    title,
    smsText,
    tags,
}) => {
    return {
        tags,
        channel: 'Website',
        feature: 'Telehealth',
        data: {
            $canonical_url: branchDeepLink,
            $og_image_url: 'https://www.zocdoc.com/favicon.ico',
            $og_title: title,
            $custom_sms_text: `${smsText} {{ link }}`,
        },
    };
};

export const fetchBranchLink = async ({ branchDeepLink, tags }) => {
    const branchLinkOptions = {
        tags,
        channel: 'mWeb',
        feature: 'Telehealth',
        data: {
            $canonical_url: branchDeepLink,
        },
    };

    await loadBranchApi();
    return new Promise((resolve, reject) => {
        window.branch.link(branchLinkOptions, (err, link) => err ? reject(err) : resolve(link));
    });
};

export const sendBranchSms = async ({ phoneNumber, linkData }) => {
    const options = { make_new_link: false };

    await loadBranchApi();
    return new Promise((resolve, reject) => {
        window.branch.sendSMS(phoneNumber, linkData, options, err => err ? reject(err) : resolve(null));
    });
};

export const SEND_SMS_RESULT = {
    failure: 'tel-send-sms/failure',
    loading: 'tel-send-sms/loading',
    none: 'tel-send-sms/none',
    success: 'tel-send-sms/success',
};
